import React from "react";
import { useSelector } from "types/store";
import * as tagsReducer from "containers/Tags/reducer";
import styles from "components/Templates/style.module.css";
const TemplateItemTag = ({ tagId, rightPanel }) => {
    const allTags = useSelector((state) => tagsReducer.getTags(state));
    const retTagIcon = allTags[tagId]?.icon;
    if (!allTags[tagId])
        return null;
    return (React.createElement("div", { className: styles.templateTagWrapper },
        retTagIcon && (React.createElement("div", { className: rightPanel ? styles.rightPanelTagIconWrapper : styles.templateTagIconWrapper },
            React.createElement("img", { className: rightPanel ? styles.rightPanelTagIcon : styles.templateTagIcon, src: retTagIcon }))),
        React.createElement("div", { className: rightPanel ? styles.rightPanelTagLabel : styles.templateTagLabel }, allTags[tagId]?.label)));
};
export default TemplateItemTag;
